import c from 'classnames';

import { blue100HoverBackground } from './styles';
import { MenuItemOverrides } from './types';

export const BASE_MENU_ITEM_PROPS = {};

export const getDefaults = (classes: any, disabled: boolean): MenuItemOverrides => {
  const { iconClassName, itemClassName } = classes;
  return {
    BaseMenuItem: {
      className: c(
        'h-40 flex items-center justify-between px-10 rounded-8',
        itemClassName,
        disabled ? 'opacity-50 pointer-events-none' : 'group',
      ),
    },
    EndIcon: {
      className: iconClassName,
    },
    Typography: {
      className: 'me-20',
      variant: 'body-short-02',
    },
  };
};

export const COLOR_CLASSES = {
  danger: {
    iconClassName: 'text-icon-error',
    itemClassName:
      'text-text-error hover:bg-bg-error-light focus:bg-bg-error-light active:bg-border-error active:text-text-error-dark',
  },
  ghost: {
    iconClassName: 'text-link-external',
    itemClassName: c(
      'text-link-external hover:text-link-external-hover focus:text-link-external-hover active:text-link-external-hover active:bg-border-accent',
      blue100HoverBackground,
    ),
  },
  primary: {
    iconClassName: 'text-icon-secondary',
    itemClassName:
      'text-text-secondary hover:bg-s-info-light focus:bg-s-info-light active:bg-field active:text-text-primary',
  },
};
